import React from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Card } from "react-bootstrap";
import { RootState } from "../services/rootReducer";
import { doQuery } from "../services/Query_Slice";
import { getCurrentFacets } from 'services/Facets_Slice';
import { getMissionColorMap } from 'services/View_Slice';
import { getSummaryShort } from 'services/Summary_Slice';
import styles from "./css/Query.module.css";
import CONSTANTS from "../constants";
var urldecode = require('urldecode');

function QueryDebugPanel() {
    const dispatch = useDispatch();

    const { facetMap, facetSelected, currentFacetMap } = useSelector(
        (state: RootState) => ({
            facetMap: state.Facets.facetMap,
            facetSelected: state.Facets.facetSelected,
            currentFacetMap: state.Facets.currentFacetMap,
        }),
        shallowEqual
    );

    const { result, request, requestDone, facetCounts } = useSelector(
        (state: RootState) => ({
            result: state.Query.result,
            request: state.Query.request,
            requestDone: state.Query.requestDone,
            facetCounts: state.Query.facetCounts,
        }),
        shallowEqual
    );

    const { freeTextSearch } = useSelector(
        (state: RootState) => ({
            freeTextSearch: state.Search.freeTextSearch,
        }),
        shallowEqual
    );

    const { numFound, facetFound } = useSelector(
        (state: RootState) => ({
            numFound: state.Summary.numFound,
            facetFound: state.Summary.facetFound,
        }),
        shallowEqual
    );

    const { total, viewType, cursorStart, cursorRows, listSortedFeld, listSortedOrder, calRangeUsed, calRangeValue, missionColorMap, dateIntervalFrom, dateIntervalTo } = useSelector(
        (state: RootState) => ({
            total: state.View.total,
            viewType: state.View.viewType,
            cursorStart: state.View.cursorStart,
            cursorRows: state.View.cursorRows,
            listSortedFeld: state.View.listSortedFeld,
            listSortedOrder: state.View.listSortedOrder,
            calRangeUsed: state.View.calRangeUsed,
            calRangeValue: state.View.calRangeValue,
            missionColorMap: state.View.missionColorMap,
            dateIntervalFrom: state.View.dateIntervalFrom,
            dateIntervalTo: state.View.dateIntervalTo,
        }),
        shallowEqual
    );

    return (
        <div>
            <h1>Debug info:</h1>
            <div>Version: {CONSTANTS.VERSION}</div>

            <br/><br/>
            <div>
            <h1>Actions:</h1>
            <button
                onClick={(e) => {
                    dispatch(doQuery(request))
                }}>
                [ Run query ]
            </button>

            <button
                onClick={(e) => {
                    dispatch(getCurrentFacets(facetMap, facetSelected, CONSTANTS.DEFAULT_OPERATOR_TO_USE, freeTextSearch, dateIntervalFrom, dateIntervalTo)) /* === AND/OR OPERATOR FEATURE - USING DEFAULT CONSTANT === */
                }}>
                [ Run getCurrentFacets ]
            </button>

            <button
                onClick={(e) => {
                    dispatch(getSummaryShort(facetMap, facetSelected, freeTextSearch, CONSTANTS.DEFAULT_OPERATOR_TO_USE, dateIntervalFrom ?? undefined, dateIntervalTo ?? undefined)) /* === AND/OR OPERATOR FEATURE - USING DEFAULT CONSTANT === */
                }}>
                [ Run getSummaryShort ]
            </button>

            <button
                onClick={(e) => {
                    dispatch(getMissionColorMap())
                }}>
                [ Run getMissionColorMap ]
            </button>
            </div>


            <br/><br/>

            <h2>Search field:</h2>
            <div>
            freeTextSearch:{freeTextSearch}
            </div><br/>


            <br/><br/>

            <h2>View:</h2>

            <div>
                UI: missions color map:{JSON.stringify(missionColorMap)}
            </div><br/>

            <div>
                Total:{total}
            </div><br/>
            <div>
                Type:{viewType}
            </div><br/>
            <div>
                Cursor start:{cursorStart}<br/>
                Cursor rows:{cursorRows}<br/>
                Sorted field:{listSortedFeld}<br/>
                Sorted order:{listSortedOrder}<br/>
                Calendar range type:{calRangeUsed}<br/>
                calendar range:{calRangeValue}<br/>
            </div><br/>


            <h2>Summary:</h2>
            <div>
                Total found:{JSON.stringify(numFound)}
            </div><br/>
            <div>
                Facets found:{JSON.stringify(facetFound)}
            </div><br/>


            <h2>Facets:</h2>
            <div>
                All facets:{JSON.stringify(facetMap)}
            </div><br/>
            <div>
                Current facets:{JSON.stringify(currentFacetMap)}
            </div><br/>

            <div>
                Facets selected:{JSON.stringify(facetSelected)}
            </div><br/>

            <div>
                Facet counts: {JSON.stringify(facetCounts)}
            </div><br/><br/>

            <h2>Query:</h2>
            <div>
                Query request:
                <Card className={styles.glMaxWidth}>
                    {urldecode(JSON.stringify(request))}
                </Card>
            </div><br/>

            <div>
                Query request done:
                <Card className={styles.glMaxWidth}>
                    {urldecode(JSON.stringify(requestDone))}
                </Card>
            </div><br/>

            <div>
                Query result:
                <Card className={styles.glMaxWidth}>
                    {JSON.stringify(result)}
                </Card>
            </div>
            <br/><br/>
        </div>
    );
}

export default React.memo(QueryDebugPanel);
